import { render, staticRenderFns } from "./ManageFacebookPageSubscriptionsModal.vue?vue&type=template&id=5e08419e&scoped=true"
import script from "./ManageFacebookPageSubscriptionsModal.vue?vue&type=script&lang=js"
export * from "./ManageFacebookPageSubscriptionsModal.vue?vue&type=script&lang=js"
import style0 from "./ManageFacebookPageSubscriptionsModal.vue?vue&type=style&index=0&id=5e08419e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e08419e",
  null
  
)

export default component.exports